import { apiClient, type ChargeTypeExEntity } from '@/libs/api'

export type FetchChargeTypeQuery = {
  tenantKey: string
  chargeTypeId: number
}

export type FetchChargeTypeResponse = {
  data: ChargeTypeExEntity
}

export const fetchChargeType = async (
  { tenantKey, chargeTypeId }: FetchChargeTypeQuery,
  signal?: AbortSignal
): Promise<FetchChargeTypeResponse> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .charge_types._id(chargeTypeId)
    .$get({
      config: {
        signal
      }
    })
  return { data }
}
